import { useEffect } from 'react';

export const useProfileMenuInteractions = ({
	open,
	isMobile,
	onClose,
	wrapRef,
}) => {
	useEffect(() => {
		if (!open || isMobile) {
			return undefined;
		}

		const handleClickOutside = (event) => {
			if (wrapRef.current && !wrapRef.current.contains(event.target)) {
				onClose();
			}
		};

		document.addEventListener('mousedown', handleClickOutside);

		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, [open, isMobile, onClose, wrapRef]);

	useEffect(() => {
		if (!open || !isMobile) {
			return undefined;
		}

		const previousOverflow = document.documentElement.style.overflow;
		document.documentElement.style.overflow = 'hidden';

		const handleEscape = (event) => {
			if (event.key === 'Escape') {
				onClose();
			}
		};

		document.addEventListener('keydown', handleEscape);

		return () => {
			document.documentElement.style.overflow = previousOverflow;
			document.removeEventListener('keydown', handleEscape);
		};
	}, [open, isMobile, onClose]);
};
